import styled from 'styled-components';
import { color } from '~/assets/styles/colors';
import { Container } from 'reactstrap';

export const ContainerExtrato = styled(Container)`
	margin-top: 20px;
`;

export const FilterAndDown = styled.div`
	display: flex;
	justify-content: right;
	margin-bottom: 10px;
`;

export const TextClick = styled.div`
	color: ${color.blue};
	cursor: pointer;
	margin-right: 20px;
	font-size: 16px;
`;
